<template>
  <CookieLaw buttonText="Accetta">
    <div slot-scope="props">
      <v-row align="center">
        <v-col cols="12" md="11">
          <p class="py-0 px-2 px-md-4"><span v-translate>We use cookies, including third-party cookies, to ensure the best possible experience on our site and to send you advertising and services in line with your preferences. By continuing to browse, you consent to the use of cookies. For more information or to change the settings, see our</span><router-link :to="{ name: 'PrivacyPolicy'}">Cookie Policy.</router-link></p>
        </v-col>
        <v-col cols="12" md="1" class="py-0 pa-md-0 ">
          <a class="pa-md-0 pl-2 button" @click="props.accept"><span v-translate>Accept</span></a>
        </v-col>
      </v-row>
    </div>
  </CookieLaw>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'BannerCookie',

  components: {
    CookieLaw
  }
}
</script>

<style scoped lang="scss">

.Cookie--base {
  background-color: $c-dark-grey;
  color: $c-white;
  padding: 0;

  p {
    font-size: 10px;
    color: $c-white;
    margin-bottom: 0 !important;
  }

  a {
    font-size: 10px;
    color: $c-red;

    &.button {
      color: $c-white;
      font-size: 14px;
      font-family: Barlow;
    }
  }

  .Cookie__button {
    background-color: $c-red;
  }
}

</style>
